import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './entradaForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	getLista, getListaProduto, getListaUnidade
} from './entradaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

class EntradaDashboard extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaProduto();
		this.props.getListaUnidade();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaProduto();
			this.props.getListaUnidade();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {

		let lista = [];
		this.props.lista.filter(item => {
			// //RIO VERDE (SERTÃO), PORTO ALEGRE DO NORTE, ÁGUA BOA, BARRA DO GARÇAS
			// if (![60, 9 , 1 , 3 ].includes(item.id_unidade)) {
			// 	return false;
			// }
			//Apenas compras
			if (item.id_tipo != 1) {
				return false;
			}

			if (item.datahora_descarga && !(
				(DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_programacao) || '').includes('Ontem') 
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_programacao) || '').includes('Hoje')
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_carga) || '').includes('Ontem') 
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_carga) || '').includes('Hoje')
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_chegada) || '').includes('Ontem') 
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_chegada) || '').includes('Hoje')
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_descarga) || '').includes('Ontem') 
				|| (DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_descarga) || '').includes('Hoje'))) {
				return false;
			}

			return true;
		}).forEach(item => {
			(item.itens || []).forEach(entradaItem => {
				lista.push({
					...item,
					id_item: `${item.id}-${entradaItem.id}`,
					nome_produto: entradaItem.nome_produto,
					quantidade: entradaItem.quantidade,
					preco: entradaItem.preco,
					prazo: entradaItem.prazo
				});
			});
		});

		lista.sort((a, b) => {
			return (a.datahora_descarga || DateFormat.getDataHoraAtual()) < (b.datahora_descarga || DateFormat.getDataHoraAtual()) ? -1 : 1;
		});

        return (
            <div>
                <Content>
					<ContentCard>
						<ContentCardBody>	
							<input className='form-control'
								placeholder='Pesquisar'
								type='text'
								value={this.state.pesquisar}
								onChange={e => {
									this.setState({ ...this.state, pesquisar: e.target.value });
								}} />
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Unidade</Th>
										<Th alignCenter>Distribuidora</Th>
										<Th alignCenter>Veículo</Th>
										<Th alignCenter>Produto</Th>
										<Th alignCenter>Programação</Th>
										<Th alignCenter>Carga</Th>
										<Th alignCenter>Chegada Base</Th>
										<Th alignCenter>Descarga</Th>
										<Th alignCenter>Quantidade</Th>
										<Th alignCenter>Preço</Th>
										<Th alignCenter>Prazo</Th>
									</Tr>
								</THead>
								<TBody>
									{lista.filter(item => {
										if (this.state.pesquisar
											&& !(`${item.nome_unidade} ${item.nome_distribuidora || ''} ${item.placa_veiculo || ''} ${item.nome_produto || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
											return false;
										}
										return true;
									}).map(item => {			
																
										return (
											<Tr key={item.id_item}>
												<Td alignCenter>{item.nome_unidade}</Td>
												<Td alignCenter>{item.nome_distribuidora}</Td>
												<Td alignCenter>{item.placa_veiculo}</Td>
												<Td alignCenter>{item.nome_produto}</Td>
												<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_programacao)}</Td>
												<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_carga)}</Td>
												<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_chegada)}</Td>
												<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTelaDescritivo(item.datahora_descarga)}</Td>
												<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.quantidade, 0)}</Td>
												<Td alignCenter>{FormatUtils.formatarValorTela(item.preco, 0)}</Td>
												<Td alignCenter>{FormatUtils.formatarValorTela(item.prazo, 0)}</Td>
											</Tr>
										)
									})}
								</TBody>
							</Table>
						</ContentCardBody>
					</ContentCard>
                </Content>
            </div>
        )
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.entrada,
	modoTela: state.entrada.modoTela,
	lista: state.entrada.lista,
    listaVeiculo: state.entrada.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	getLista, getListaProduto, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EntradaDashboard);
